import { notify, TYPE, DURATION } from "@8x8/oxygen-toaster";
import { generatePath } from "react-router-dom";

import * as PATHS from "@/react/routing/constants";
import Debug, { snap } from "@/react/debug";

class JobNotificationsManager {
  constructor() {}

  buildDefaultMessage(jobUuid) {
    return `Started async job with ID '${jobUuid}'.`;
  }

  /**
   * Show a notification for a long-running job.
   * @param {string} jobUuid - The UUID of the job.
   * @param {Function} buildMessage - Function that gets the UUID to build a user-facing message.
   */
  showJobNotification(jobUuid, buildMessage = null) {
    if (!jobUuid) {
      throw new Error(
        "showJobNotification should not be called with an invalid or missing job UUID."
      );
    }

    const jobPath = generatePath(PATHS.JOBS, { jobId: jobUuid });
    const message = buildMessage
      ? buildMessage(jobUuid)
      : this.buildDefaultMessage(jobUuid);
    Debug.log(
      `[JobNotificationsManager] Generated path to job: ${jobPath}.`,
      snap({ jobUuid, message })
    );
    notify({
      type: TYPE.info,
      content: message,
      duration: DURATION.INFINITE,
      actions: [
        {
          title: "View Job",
          callback: () => {
            // Navigate to the job details page
            window.location.href = jobPath;
          },
        },
        {
          title: "Copy UUID",
          callback: () => {
            navigator.clipboard.writeText(jobUuid).catch((e) => {
              Debug.error("Failed to copy job UUID to clipboard:", e);
            });
          },
        },
      ],
    });
  }
}

export default new JobNotificationsManager();
